import Lesson from 'models/Lesson';
import React from 'react';
import Context from './context';

export function useLesson(): Lesson {
  return React.useContext(Context).lesson as Lesson;
}
